export default __webpack_public_path__ + "static/media/airport-icon.561ad86e.svg";